import { useDispatch, useSelector, RootStateOrAny } from 'react-redux';
import { PhoneNumberEditor } from '@components/PhoneNumberEditor';
import { updateStaffUserPhone } from '@containers/Admin/containers/StaffPage/actions';

export const EditPhoneNumber = () => {
  const dispatch = useDispatch();
  const saving = useSelector(
    (state: RootStateOrAny) => state.getIn(['staffPage', 'phoneUpdateLoading']),
  );
  const saveRevision = useSelector(
    (state: RootStateOrAny) => state.getIn(['staffPage', 'phoneUpdateRevision']),
  );
  const userData = useSelector(
    (state: RootStateOrAny) => state.getIn(['staffPage', 'userData']),
  );
  const { id, phone, mfaStatus } = userData || {};

  return <PhoneNumberEditor
    userId={id}
    phone={phone}
    mfaStatus={mfaStatus}
    saving={Boolean(saving)}
    saveRevision={saveRevision}
    onSave={(userId, phoneNumber) => dispatch(updateStaffUserPhone(userId, phoneNumber))}
  />;
};
